module.exports = __webpack_public_path__ + "static/1-2e1b4b491f3757e256e9db713d478bf3.jpg";